import React, { Component } from 'react';
import {Grid,Card, CardContent, Typography,Backdrop,CircularProgress,Snackbar } from "@material-ui/core";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import {MaterialInput } from '@findep/mf-landings-core'
import formatNumber from '../../helpers/formatNumber'
import { css } from '@emotion/react'
import { CataloguesService } from '../../services/LandingV4'
import { restoreFromSessionStorage} from "../pages/afi/restoreSessionStorage"
import { Alert } from '@material-ui/lab';
import { ReferidosService } from '../../services/LandingV4/referidos';
import { withThemeProps } from "@findep/microfronts-core"
import SliderRange from '../elements/SliderRange';
import { withStyles } from '@material-ui/core/styles';
import { navigate } from '../../helpers/queryNavigate';
import { getPathById } from "../../helpers/array"
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'

const styles = {
  roundedButton: {
    width: '100%',
    minHeight: '58px',
    borderRadius: '999px',
    padding: '14px 36px',
    textTransform: 'none',
    backgroundColor: 'transparent',
    border: '2px solid #ff7a45',
    fontSize: '17px',
    color: '#ff7a45',
    fontWeight: 600,
    letterSpacing: '0.3px',
    boxShadow: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 122, 69, 0.06)',
      border: '2px solid #ff7a45',
      boxShadow: 'none',
      transform: 'translateY(-1px)',
    },
    '&:disabled': {
      backgroundColor: 'transparent',
      border: '2px solid #e5e7eb',
      color: '#9ca3af',
      boxShadow: 'none',
    },
    '& .MuiButton-endIcon': {
      marginLeft: '10px',
    },
  },
};

const root = css`
    background: #ffffff;
    color: #1a1a1a;
    padding: 28px 32px 24px;
    max-width: 600px;
    width: 100%;
    border-radius: 22px;
    border: 1px solid rgba(27, 107, 74, 0.08);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 4px 40px rgba(0, 0, 0, 0.08);

    @media (max-width: 959px) {
        max-width: none;
        padding: 22px 20px 20px;
        border-radius: 26px;
        box-shadow: 0 10px 35px rgba(32, 37, 41, 0.10);
    }
`
const bDrop = css`
    z-index:9999;
    color: '#fff';
`

const titleCss = css`
    color: #1a1a1a;
    font-family: 'Jost', 'Helvetica Neue', Arial, sans-serif;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.3;
    margin: 0 0 24px 0;

    @media (max-width: 959px) {
        font-size: 20px;
        margin-bottom: 20px;
    }
`

const fieldLabelCss = css`
    display: block;
    margin-bottom: 8px;
    font-family: 'DM Sans', 'Helvetica Neue', Arial, sans-serif;
    font-size: 13px;
    line-height: 1.6;
    font-weight: 600;
    color: #3d3d3d;
`

const requiredAsteriskCss = css`
    color: #ef4444;
    margin-left: 2px;
`

const fieldShellCss = css`
    margin-bottom: 4px;

    .MuiFormControl-root,
    .MuiTextField-root {
        width: 100%;
        margin: 0;
    }

    .MuiInputLabel-root {
        display: none;
    }

    .MuiOutlinedInput-root {
        min-height: 47px;
        background: #ffffff;
        border-radius: 12px;
        overflow: hidden;
    }

    .MuiOutlinedInput-root.Mui-focused {
        background: #ffffff;
    }

    .MuiOutlinedInput-notchedOutline {
        border-color: #e2e5e9;
    }

    .MuiOutlinedInput-notchedOutline legend {
        max-width: 0.01px;
    }

    .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline,
    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: #e2e5e9;
        border-width: 1px;
    }

    .MuiOutlinedInput-input {
        padding: 13px 16px;
        font-family: 'DM Sans', 'Helvetica Neue', Arial, sans-serif;
        font-size: 15px;
        line-height: 1.3;
        font-weight: 400;
        color: #3d3d3d;
    }

    .MuiOutlinedInput-input::placeholder {
        color: #9ca3af;
        opacity: 1;
    }

    @media (max-width: 959px) {
        .MuiOutlinedInput-root {
            min-height: 50px;
        }

        .MuiOutlinedInput-input {
            padding: 14px 16px;
            font-size: 16px;
        }
    }
`

const buttonWrapCss = css`
    margin-top: 8px;
    margin-bottom: 16px;
`

const disclaimerCss = css`
    margin-top: 0;
    font-family: 'DM Sans', 'Helvetica Neue', Arial, sans-serif;
    font-size: 11px;
    line-height: 1.7;
    color: #6b7280;
    text-align: left;

    a {
        color: #ff7a45;
        text-decoration: underline;
        font-weight: 600;
        display: inline;
        white-space: normal;
    }

    @media (max-width: 959px) {
        font-size: 10px;
        line-height: 1.8;
        overflow-wrap: break-word;

        a {
            word-break: break-word;
        }
    }
`

const dividerCss = css`
    display: none;
`

const warningModalContentCss = css`
  padding: 0 !important;
  background: transparent;
`

const warningModalInnerCss = css`
  width: 100%;
  max-width: 520px;
  margin: 0 auto;
  padding: 36px 40px 32px;
  background: #fafaf8;
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.28);
  text-align: center;

  @media (max-width: 959px) {
    padding: 28px 22px 24px;
  }
`

const warningModalIconWrapCss = css`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`

const warningModalIconCss = css`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #fef3c7;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f59e0b;
  font-size: 32px;
`

const warningModalTitleCss = css`
  margin: 0 0 16px;
  font-family: 'Jost', 'Helvetica', sans-serif;
  font-size: 24px;
  line-height: 30px;
  font-weight: 600;
  color: #1e293b;
`

const warningModalTextCss = css`
  margin: 0 auto 28px;
  max-width: 420px;
  font-family: 'DM Sans', 'Helvetica', sans-serif;
  font-size: 14px;
  line-height: 1.75;
  color: #3f3f46;
`

const warningModalButtonCss = css`
  min-width: 188px;
  height: 46px;
  border: 0;
  border-radius: 12px;
  padding: 0 28px;
  background: #ff7a45;
  color: #ffffff;
  font-family: 'DM Sans', 'Helvetica', sans-serif;
  font-size: 13px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 1.8px;
  text-transform: uppercase;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(255, 122, 69, 0.28);
  transition: all 0.2s ease;

  &:hover {
    background: #ff6b30;
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(255, 122, 69, 0.35);
  }

  &:active {
    transform: translateY(0);
  }
`

const catalogues = new CataloguesService();

class formCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            flujo: restoreFromSessionStorage('flujo'),
            visible:false,
            nombre: "",
            apellido: "",
            cp: "",
            telefono: "",
            monto:2500,
            msj_error:"",
            severityColor:"warning",
            covered: "",
            sucursalId: "", 
            esMovil:false,
            txtDollar:"",
            txtContactInfo:"",
            idMedio: false,
            dialogOpen: false,
            openWarningModal: false,

            _errors: {
                nombre: {
                  error: false,
                  errorType: this.props.inputHelperTextName,
                },
                apellido: {
                  error: false,
                  errorType: this.props.inputHelperTextPaternalLastName,
                },                
                telefono: {
                  error: false,
                  errorType: this.props.inputErrorMessagePhone,
                },
                cp: {
                  error: false,
                  errorType: 'empty',
                },
                monto: {
                  error: false,
                  errorType: this.props.inputErrorMessageEmail,
                }
              },
        }

      this.handleChange = this.handleChange.bind(this)
      this._handleError = this._handleError.bind(this)      
      this.handleCPChange = this.handleCPChange.bind(this)    
      // console.log(this.props.pageContext.locale)
    }

    componentDidMount() {
      const esMovil = /Mobi|Android|iPhone/i.test(navigator.userAgent);
      this.setState({ esMovil });
      let dolar=this.props.pageContext?.locale==="enUS" ? "dollars":"dólares"
      this.setState({txtDollar: dolar})
      let contactInfo=this.props.pageContext?.locale==="enUS"
        ? <>Or call us at <a href="tel:8008912778" style={{ color: "#ff7a45", textDecoration: "underline", fontWeight: 600, fontSize: '18px' }}>800-891-2778</a>.</>
        : <>o si prefieres contáctanos al <a href="tel:8008912778" style={{ color: "#ff7a45", textDecoration: "underline", fontWeight: 600, fontSize: '18px' }}>800-891-2778</a>.</>
      this.setState({txtContactInfo: contactInfo})
      const urlParams = new URLSearchParams(window.location.search);
      let term = urlParams.get('term') || 'notYet'
      if(term !=='notYet'){if(term==="idmedio_452"){this.setState({idMedio: true})}}
    }
    
    //FUNCION PARA EL CODIGO POSTAL
  async handleCPChange(data) {
    this.setState({bdHabilita:true})
    const state = { cp: data?.value }
    
    if (data.hasOwnProperty('error')) {
      state._errors = JSON.parse(JSON.stringify(this.state._errors))
      state._errors.cp = {
        error: data.error,
        errorType: data.errorType || ''
      }
    }

    let flujo = JSON.parse(sessionStorage.getItem('flujo'))
    const tmp = Object.assign({}, this.state, state)
    const self = this

    self.setState(tmp, () => {
      // if (!self.state._errors.cp.error) {
      //   catalogues.getNeighborhoods(self.state.cp, this.state.flujo.creditApplicationId)
      //     .then((response) => {        
      //         flujo = {
      //             ...flujo,
      //             covered: response.data.coverageResult,
      //             sucursalId: response.data?.neighborhoods[0]?.sucursalId 
      //         }
      //         this.setState({ flujo })
      //         sessionStorage.setItem('flujo', JSON.stringify(flujo))
      //         let _asentamientos = [...response.data.neighborhoods]
      //         if (response.data.coverageResult === 'Covered' || response.data.coverageResult === 'CoveredNoLocalBranch') {                  
      //             self.setState({errorService:true,msj_error:"cobertura exitosa para este codigo postal",severityColor:"success"})
      //         } else {              
      //             self.setState({ cp: '' ,errorService:true,msj_error:"no hay cobertura para esta codigo postal, intente de nuevo",severityColor:"warning"})
      //         }
      //     })
      //     .catch(error => {
      //       console.error("getNeighborhoods:",error)
      //     })          

      // }
    })
  }

      //GUARDA LOS ESTADOS DE LOS INPUTS
  handleChange(prop, data) {
    // console.log("prop, data",prop, data?.value)
    const state = {
      [prop]: data?.value
    }
    
    this._handleError(prop, {}, false)

    const tmp = Object.assign({}, this.state, state)
    this.setState(tmp, () => {

      // if (prop === "telefono") {         
      //   if (this.state.telefono.length >= 10) {
      //     this.phoneValidate()
      //   } 
      // }

    })

  }

  _handleError(prop, data, bool = true) {
    let { _errors } = this.state
    _errors[prop] = {
      ..._errors[prop],
      error: bool
    }
    this.setState({ _errors })

  }

   async phoneValidate() {    
     await catalogues.postPhoneValidate(this.state.flujo.creditApplicationId, this.state.telefono)
      .then((response) => {        
        if (response.data.isValid) {
          this.setState({errorService:true,msj_error:"telefono validado exitosamente",severityColor:"success"})
          this.setState({ srv_tel: false })

        } else {
          const _errors = JSON.parse(JSON.stringify(this.state._errors))
          _errors.telefono = {
            error: true,
            errorType: 'Por favor ingresa un número de teléfono celular válido de 10 dígitos'
          }
          this.setState({ telefono:'' ,errorService:true,msj_error:"No fue posible validar el teléfono intente con otro número telefonico",severityColor:"warning"})
          
        }
      })
      .catch(error => {
        this.setState({ errorService: true ,msj_error:"No fue posible validar el teléfono intente nuevamente"})
        console.error(error)
      })
      
  }

  async handleChangeSimula(element) {           
        this.setState({ monto: element?.mount })   
        // console.log("montoState",element?.mount)     
    }

  async token(){
    let token
    const ref =new ReferidosService("AFI");
    await ref.token()
    .then((r) => {
      // console.log("TokenSrv",r)
      token=r?.data.token
    })
    .catch(error =>{console.log("referidosSrv",error)})
    return token
  }

  async saveData(){
    const { nombre,apellido,cp,telefono,monto,idMedio}=this.state    
    const ref =new ReferidosService("AFI");
    let urlParams = new URLSearchParams(window.location.search)
    const source = urlParams.get('source') || urlParams.get('utm_source') || 'search_engine'
    const medium = urlParams.get('medium') || urlParams.get('utm_medium') || 'search'
    const campaign = urlParams.get('campaign') || urlParams.get('utm_campaign') || 'seo'
    const term = urlParams.get('term') || urlParams.get('utm_term') || 'idmedio_1391'
    const content = urlParams.get('content') || urlParams.get('utm_content') || 'redirect_sitioafi'
    let sellerPartner = urlParams.get('sellerPartner') || ''
    const sellerId = urlParams.get('sellerId') || ''
    let branchId=urlParams.get('branchId') || 0
    let token = await this.token()

    // let product=monto <= 2499 ? 4 : 2
    ref.setUtmSource(source)
    ref.setUtmMedium(medium)
    ref.setUtmCampaign(campaign) 
    ref.setUtmTerm(term)    
    ref.setUtmContent(content)
    ref.setProductId(2)
    ref.setRequestedAmount(monto)
    ref.setSellerPartner(sellerPartner)
    ref.setSellerId(sellerId)
    ref.setBranchId(Number(branchId))
    ref.setFirstName(nombre)
    ref.setLastName(apellido)
    ref.setMobileNumber(telefono)
    ref.setPostalCode(cp)
    ref.setToken(token)
      
    await ref.send()
    .then((r) => {
      if(r?.data.redirectUrl){        
        window.dataLayer.push({'event': 'formulario-referidos'});                        
        if(idMedio){
          this.setState({dialogOpen:true,bdropOn:false})
        }else{
          this.setState({bdropOn:false,errorService:true,msj_error:"redireccionado",severityColor:"success"}) 
          let navigateUrl = getPathById(this.props.pageContext.errorPath, 'referidos-gracias')
          navigate(navigateUrl)
          // window.location.href = r?.data.redirectUrl;        
        }
      }else{
        this.setState({bdropOn:false,errorService:true,msj_error:"no se encontro url para redireccionar",severityColor:"warning"})
      }
           
    }) 
    .catch(error =>{
      console.log("referidosSrv",error)      
      this.setState({bdropOn:false,errorService:true,msj_error:error?.data,severityColor:"info"})
    })

  }

  async nextStep(){
    this.setState({bdropOn:true})
    const { nombre,apellido,cp,telefono,monto, _errors}=this.state
    if(
      nombre !=="" &&
      apellido !=="" &&
      cp !=="" &&
      telefono !=="" &&
      monto !==""
    ){
      this.saveData()
    }else{
      // Marcar campos vacíos con error
      const newErrors = {
        nombre: { ..._errors.nombre, error: nombre === "" },
        apellido: { ..._errors.apellido, error: apellido === "" },
        cp: { ..._errors.cp, error: cp === "" },
        telefono: { ..._errors.telefono, error: telefono === "" },
        monto: { ..._errors.monto, error: monto === "" }
      }
      this.setState({
        bdropOn: false,
        openWarningModal: true,
        _errors: newErrors
      })
    }
    // setTimeout(()=>this.setState({bdropOn:false}),1500)

  }
  
  
  render(){
      
       const { nombre,apellido,cp,telefono,monto,errorService,bdropOn,msj_error,severityColor,esMovil,dialogOpen,txtContactInfo}=this.state
       const {
              classes,
              alertMessage="Por el momento el servicio no se encuentra disponible",
              titulo="¡Envíanos tus datos para dar el siguiente paso!",
              inName="Nombre",
              inLastName="Apellido",
              inPhone="Teléfono",
              inCp="Código Postal",
              subtitle="¿Cuánto necesitas?",
              lblSend="Continuar",
              lblInfo=<>Al hacer click en "continuar", aceptas enviar tu información a Apoyo Financiero, Inc, quien se compromete a usarla conforme a su politica de privacidad. Consulta aqui la <a href="/es/terminos-condiciones?option=privacy-notice-california" target='_blank'  rel="nofollow noopener noreferrer" style={{ textDecoration: "underline",color:"#ff7a45"}}>Notificacion sobre los Derechos de Privacidad de California</a></>,
              lblInfoSend="Espera la llamada de uno de nuestros representantes en breve para iniciar tu solicitud de préstamo.",
              dlgTitle="¡Gracias por tu preferencia!",
              dlgBody="Hemos recibido tus datos, en breve uno de nuestros ejecutivos se pondrá en contacto para continuar con tu solicitud.",
              dlgFooter="Salir",
              warningModalTitle="Campos incompletos",
              warningModalMessage="Por favor, completa todos los campos obligatorios antes de continuar.",
              warningModalButton="Aceptar",
            }= this.props
       
       return (

    <Card css={root} elevation={0}>
      <CardContent style={{ padding: 0 }}>
        <div>
            <h2 css={titleCss}>{titulo}</h2>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <div css={fieldShellCss}>
                        <label css={fieldLabelCss}>{inName}<span css={requiredAsteriskCss}>*</span></label>
                        <MaterialInput
                            label=""
                            placeholder=""
                            variant="outlined"
                            fullWidth
                            required
                            name="nombre"
                            value={nombre}
                            transform={(value) => value.toUpperCase()}
                            onChange={(_event, component) => this.handleChange('nombre', component)}
                            error={this.state._errors.nombre.error}
                        />
                    </div>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <div css={fieldShellCss}>
                        <label css={fieldLabelCss}>{inLastName}<span css={requiredAsteriskCss}>*</span></label>
                        <MaterialInput
                            label=""
                            placeholder=""
                            variant="outlined"
                            fullWidth
                            required
                            name="apellido"
                            value={apellido}
                            transform={(value) => value.toUpperCase()}
                            onChange={(_event, component) => this.handleChange('apellido', component)}
                            error={this.state._errors.apellido.error}
                        />
                    </div>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <div css={fieldShellCss}>
                        <label css={fieldLabelCss}>{inPhone}<span css={requiredAsteriskCss}>*</span></label>
                        <MaterialInput
                            label=""
                            placeholder=""
                            variant="outlined"
                            fullWidth
                            required
                            name="telefono"
                            value={telefono}
                            onChange={(_event, component) => this.handleChange('telefono', component)}
                            id="tus-datos-telefono"
                            type="tel"
                            pattern="^([2-9])(?!0123456789|1234567890|0987654321|9876543210|\1{9})\d{9}$"
                            accept="0-9"
                            transform={(value) => value.slice(0, 10)}
                            onError={(error) => this._handleError('telefono', error)}
                            error={this.state._errors.telefono.error}
                        />
                    </div>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <div css={fieldShellCss}>
                        <label css={fieldLabelCss}>{inCp}<span css={requiredAsteriskCss}>*</span></label>
                        <MaterialInput
                            label=""
                            placeholder=""
                            variant="outlined"
                            fullWidth
                            required
                            name="cp"
                            value={cp}
                            type="text"
                            inputmode="numeric"
                            autocomplete="postal-code"
                            pattern="[0-9]{5}"
                            accept="0-9"
                            transform={(value) => value.slice(0, 5)}
                            error={this.state._errors.cp.error}
                            onChange={(_event,component) => this.handleCPChange(component)}
                        />
                    </div>
                </Grid>
            </Grid>
            {this.state.visible &&
                 <SliderRange
                    defaultValue={2500}
                    max={4000}
                    min={750}
                    step={250}
                    alternalText={`${formatNumber(monto, 3, ',', '$', 0, '')} ${this.state.txtDollar}`}
                    onChange={(_event) => this.handleChangeSimula(_event)}
                />
            }

            <div css={buttonWrapCss}>
                <Button
                    className={classes.roundedButton}
                    onClick={()=>this.nextStep()}
                    endIcon={<ArrowForwardRoundedIcon />}
                >
                    {lblSend}
                </Button>
            </div>

            <div css={disclaimerCss}>
                {lblInfo}
            </div>

            <div style={{
                marginTop: '16px',
                fontSize: '14px',
                fontWeight: 600,
                color: '#3d3d3d',
                textAlign: 'center',
                fontFamily: "'DM Sans', 'Helvetica Neue', Arial, sans-serif"
            }}>
                {txtContactInfo}
            </div>
        </div>
        <Dialog open={dialogOpen} >
          <DialogTitle>
            <Typography variant="h5" component="h2" style={{ textAlign:"center", fontWeight:"bold" }}>
              {dlgTitle}                
            </Typography>
          </DialogTitle>
          <DialogContent>            
            <Typography variant="h6" component="h4" style={{ textAlign:"justify",color: "#3D3D3D" }}>
              {dlgBody}              
            </Typography>
            <br/>
            <Typography variant="h6" component="h4" style={{ textAlign:"center",fontWeight:"bold"}}>
              {dlgFooter}                  
            </Typography>
            <Typography variant="h6" component="h4" style={{ textAlign:"center",fontWeight:"bold"}}>
              {txtContactInfo}                  
            </Typography>            
            
          </DialogContent>
          
        </Dialog>
        <Backdrop css={bDrop} open={bdropOn} >
          <CircularProgress color="primary" />
        </Backdrop>
        <Snackbar open={errorService} autoHideDuration={6000} onClose={() =>{ this.setState({ errorService: false}); setTimeout(()=>this.setState({severityColor:"warning"}),1000)} }>
          <Alert variant="filled" severity={severityColor} onClose={() => this.setState({ errorService: false })}>
            {msj_error !=="" ? msj_error:alertMessage}
          </Alert>
        </Snackbar>

        <Dialog
          open={this.state.openWarningModal}
          onClose={() => this.setState({ openWarningModal: false })}
          maxWidth="sm"
          fullWidth
          disableEscapeKeyDown
          PaperProps={{
            style: {
              background: 'transparent',
              boxShadow: 'none',
              overflow: 'visible',
              borderRadius: 0,
            },
          }}
        >
          <DialogContent css={warningModalContentCss}>
            <div css={warningModalInnerCss}>
              <div css={warningModalIconWrapCss}>
                <div css={warningModalIconCss}>
                  <WarningRoundedIcon style={{ fontSize: 32 }} />
                </div>
              </div>
              <h2 css={warningModalTitleCss}>
                {warningModalTitle}
              </h2>
              <p css={warningModalTextCss}>
                {warningModalMessage}
              </p>
              <button
                type="button"
                css={warningModalButtonCss}
                onClick={() => this.setState({ openWarningModal: false })}
              >
                {warningModalButton}
              </button>
            </div>
          </DialogContent>
        </Dialog>

      </CardContent>
    </Card>
  );
}
  }
  
export default withStyles(styles)(withThemeProps(formCard, 'VDPNformCard'));

